import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";

import { EventInfoCard } from "components/CaseMap/EventInfoCard";
import { EventMarkerBadge } from "components/CaseMap/EventMarkerBadge";
import { abbreviateCount } from "components/CaseMap/helpers";
import { Z_INDEX } from "components/CaseMap/mapLayers";
import { CENTERED_MARKER_ANCHOR } from "helpers/googleMaps";

/**
 * One position's marker, plus the summary of the events at it once clicked.
 *
 * Its own component because the marker ref the InfoWindow anchors to comes from
 * a hook, which cannot live inside the cluster layer's map callback.
 *
 * `events` are the events sharing the position, newest first. Which of them the
 * summary shows is the summary's own state, and the InfoWindow mounts only while
 * it is open, so closing the marker discards it.
 */
export function EventMarker({
  events,
  position,
  summaryOpen,
  onSelect,
  onClose,
}) {
  const [markerRef, marker] = useAdvancedMarkerRef();

  // A stack wears its size the way a cluster does, so a marker standing for 79
  // events cannot be mistaken for a marker standing for one.
  const label = events.length > 1 ? abbreviateCount(events.length) : undefined;

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={position}
        title={events[0].event_type || undefined}
        zIndex={summaryOpen ? Z_INDEX.openEvent : Z_INDEX.event}
        {...CENTERED_MARKER_ANCHOR}
        onClick={onSelect}
      >
        <EventMarkerBadge label={label} selected={summaryOpen} />
      </AdvancedMarker>
      {summaryOpen && (
        <InfoWindow
          anchor={marker}
          maxWidth={320}
          onCloseClick={onClose}
          headerDisabled
        >
          <EventInfoCard events={events} position={position} />
        </InfoWindow>
      )}
    </>
  );
}
